import http from '../../config/http-common';

//Usado somente se for realmente necessário algo fora do padrão GeneralCRUD.service.js
const path = "general/type-comment"

class service {

    selectList(pageId) {

        let params = new URLSearchParams()
        params.append("pageId",pageId)
        return http.list(path + "/selectList",params);

    }

}

export default new service();

